const calculateCheckDigit = (ridWithoutCheckDigit: string) => {
    let sum = 0;
    let alternate = true;
    let checkSumDigit;

    for (let i = ridWithoutCheckDigit.length - 1; i >= 0; i--) {
        let n = parseInt(ridWithoutCheckDigit.charAt(i), 10);

        if (alternate) {
            n *= 2;
            if (n > 9) {
                n = (n % 10) + Math.floor(n / 10);
            }
        }

        sum += n;
        alternate = !alternate;
    }
    sum = Math.floor(sum / 10) * 10 + 10 - sum;

    if (parseInt(ridWithoutCheckDigit, 10) >= 700000) {
        checkSumDigit = sum % 10;
    } else {
        checkSumDigit = sum <= 6 ? sum + 3 : sum - 7;
    }

    const ridWithCheckDigit = ridWithoutCheckDigit + checkSumDigit;
    return ridWithCheckDigit;
};

/**
 * Rid checksum validator
 *
 * Validates checksum for a RID in either 111-111-1 or 1111111 format
 *
 * Helpful links:
 * - https://jira.nmdp.org/browse/MAT-1991
 * - https://confluence.nmdp.org/display/SMO/Checksum+Logic+-+RID+and+GRID
 */
export const ridChecksumValidator = (rid: string): boolean => {
    const cleanRid = rid.replace(/-/g, '');
    if (cleanRid !== '') {
        let checksumRid = cleanRid.substring(0, cleanRid.length - 1);
        checksumRid = calculateCheckDigit(checksumRid);

        if (cleanRid.toLowerCase() !== checksumRid.toLowerCase()) {
            return false;
        }
    }
    return true;
};
